import { render } from "./IconBtn.vue?vue&type=template&id=38476319"
import script from "./IconBtn.vue?vue&type=script&lang=js"
export * from "./IconBtn.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/vacatia/releases/20150122151115/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__